






import Component from 'vue-class-component';
// @ts-ignore
import CKEditor from '@ckeditor/ckeditor5-vue';
// @ts-ignore
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';
@Component({
  components: {
    ckeditor: CKEditor.component,
  },
})
export default class EditorTest extends Vue {
  @Prop() readonly value: string;
  editor = ClassicEditor;
}
